import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PropertyPage from './pages/PropertyPage';
import QRCodePage from './pages/QRCodePage';
import Dashboard from './pages/Dashboard';
import LoginPage from './pages/LoginPage';
import ListingsPage from './pages/ListingsPage';
import ProfilePage from './pages/ProfilePage';
import ForgotPasswordPage from './pages/ForgotPassword';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  // Let Firebase handle its own auth routes
  if (window.location.pathname.startsWith('/__/auth')) {
    return null;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/property/:listingId" element={<PropertyPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/dashboard" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />
        <Route path="/listings" element={
          <ProtectedRoute><ListingsPage /></ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute><ProfilePage /></ProtectedRoute>
        } />
        <Route path="/qrcodes" element={
          <ProtectedRoute><QRCodePage /></ProtectedRoute>
        } />
        <Route path="/" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;





